"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSBBEquipmentOnlyComponent = void 0;
const core_1 = require("@angular/core");
const accountsettings_service_1 = require("../../services/accountsettings.service");
const generic_content_service_1 = require("../../../shared/services/generic.content.service");
const index_1 = require("../../../shared/index");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const billing_service_1 = require("../../../billing/services/billing.service");
class CSBBEquipmentOnlyComponent {
    constructor(accountDetailService, genericContentService, modalService, billingService, cpniService) {
        this.accountDetailService = accountDetailService;
        this.genericContentService = genericContentService;
        this.modalService = modalService;
        this.billingService = billingService;
        this.cpniService = cpniService;
        this.cpinRequired = true; // DO NOT MODIFY THIS FLAG. THIS FLAG SHOULD BE SET AFTER CPIN CALL
        // eslint-disable-next-line max-len
        this.htmlString = '<button  type="button" role="button" class="btn btn-outline-primary mr-lg-4 pl-0 pr-2 py-1"><img alt="pdf-icon" class="img-responsive pdf-icon-img" src="/resources/images/mma/pdf-icon.png"></img>View Bill Details</button>';
    }
    ngOnInit() {
        this.isShowDetails = false;
        this.getEquipmentAccountDetails();
        this.viewPdfUrl = '/my_account/business_account/billing_and_payment/BillingImageDroplet.jsp?view=true&';
    }
    showDetails(linkedAccountNumber) {
        this.accountNumber = linkedAccountNumber;
        if (!this.isShowDetails) {
            this.isShowDetails = true;
            return;
        }
        else {
            this.isShowDetails = false;
        }
    }
    getEquipmentAccountDetails() {
        this.loader = true;
        this.accountDetailService.getEquipmentAccountDetails().subscribe((res) => {
            this.loader = false;
            if (res !== null && res !== undefined) {
                this.equipmentDetails = res.equipmentAccDetails;
                this.linkedEquipmentAcc = res.linkedEquipmentAcc;
                this.notLinkedEquipmentAcc = res.notLinkedEquipmentAcc;
                this.billCycleEndDate = this.equipmentDetails[0].billCycleEndDate;
                this.validatecpni();
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    linkAccount(accountId) {
        this.loader = true;
        this.accountDetailService.linkAccount(accountId).subscribe((res) => {
            this.loader = false;
            if (res !== null && res !== undefined) {
                this.getEquipmentAccountDetails();
            }
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    open(content) {
        this.modalService.open(content, { windowClass: 'dark-modal' });
    }
    validatecpni() {
        this.cpniService.cpinCheck().subscribe((res) => {
            const check = res;
            if (check.cpniRequired) {
                this.cpinRequired = true;
            }
            else {
                this.cpinRequired = false;
            }
        }, (err) => {
            this.error = err;
        });
    }
    showData(evt, date, action) {
        this.billingService.getBill(date)
            .subscribe((bill) => {
            this.billingContent = bill;
            if (this.billingContent === null) {
                this.showErrorContent();
            }
            else {
                this.loader = true;
                this.cpinRequired = false;
                setTimeout(() => {
                    this.loader = false;
                }, 2000);
            }
        }, (err) => {
            this.modelError = err;
            this.showErrorContent();
        });
    }
    showErrorContent() {
        this.genericContentService.getGenericContent('generic-errormsg-viewBillMissingB2C').subscribe((data) => {
            this.notFoundContent = data.contentText;
            this.open(this.fileNotFound);
        }, (err) => {
            // this.loading = false;
            this.modelError = err;
        });
    }
    toolTipPastDue() {
        this.genericContentService.getGenericContent('genericContentPastDueAmount').subscribe((data) => {
            this.pastDueMessage = data;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    onBlurHide() {
        this.tooltip.close();
    }
}
exports.CSBBEquipmentOnlyComponent = CSBBEquipmentOnlyComponent;
//# sourceMappingURL=bbequipmentonlyAccount.component.js.map